<div class="kop">
	<h2 class="titel">Favorieten</h2>
	<div class="knoppen">
		<app-button buttonType="secondary" icon="toevoegen" (clickit)="createFavorietMapInput()">Map</app-button>
		@if (toonFavorietKnop()) {
			<app-button icon="toevoegen" (clickit)="nieuweFavoriet()">Favoriet</app-button>
		}
	</div>
</div>

@if (groups$ | async; as groups) {
	@let heeftMappen = groups.some((g) => g.map);
	<div cdkDropListGroup cdkScrollable class="content">
		@for (group of groups; track group) {
			<div
				cdkDropList
				[cdkDropListData]="group"
				cdkDropListLockAxis="y"
				(cdkDropListDropped)="drop($event)"
				[class.losse-favorieten]="!group.map && heeftMappen"
			>
				@if (group.map) {
					<div class="map" (click)="toggleMapOpen(group.map!.id)">
						@if (group.map.id) {
							<app-icon [name]="opened.has(group.map.id) ? 'chevron-down' : 'chevron-right'" size="small" color="typography-5"></app-icon>
						}
						<app-icon name="folder" size="small" color="typography-1"></app-icon>
						@if (editingMap() !== group.map!.id) {
							<span class="map-naam" [title]="group.map!.naam">
								{{ group.map!.naam }}
							</span>
							@if (group.items.length > 0) {
								<span class="teller">{{ group.items.length }}</span>
							}
							<app-meatball-menu (click)="$event.stopPropagation()">
								<app-meatball-menu-item icon="edit" (click)="editingMap.set(group.map!.id)">Bewerken</app-meatball-menu-item>
								<app-meatball-menu-item icon="delete" (click)="confirmDeleteMap(group)">Verwijderen</app-meatball-menu-item>
							</app-meatball-menu>
						} @else {
							<app-immediate-input
								class="map-naam"
								[init]="group.map!.naam"
								(click)="$event.stopPropagation()"
								(done)="createOrUpdateFavorietMap(group.map!, $event)"
							></app-immediate-input>
						}
					</div>
				}
				@if (!group.map || opened.has(group.map!.id!)) {
					<div class="favorieten" [class.in-map]="group.map">
						@for (favoriet of group.items; track favoriet) {
							@let disabled = !favorietClickable(favoriet.allowedRollen);
							<div cdkDrag (cdkDragStarted)="dragActive = true" [cdkDragData]="favoriet" class="favoriet" [class.disabled]="disabled">
								<div *cdkDragPlaceholder></div>
								<span class="favoriet-naam" (click)="openFavoriet(favoriet)" [title]="favoriet.naam">
									{{ favoriet.naam }}
								</span>
								@if (disabled) {
									<span class="niet-beschikbaar" [appTooltip]="tooltip()">
										<app-icon name="slot" color="typography-5" size="smallest"></app-icon>
										Niet beschikbaar
									</span>
								} @else if (favoriet.hoofdpagina) {
									<span class="tag">{{ favoriet.hoofdpagina }}</span>
								}
								@if (!disabled) {
									<app-meatball-menu>
										<app-meatball-menu-item icon="edit" (click)="openFavorietDialog(groups, favoriet)">Bewerken</app-meatball-menu-item>
										<app-meatball-menu-item icon="delete" (click)="confirmDeleteFavoriet(favoriet)">Verwijderen</app-meatball-menu-item>
									</app-meatball-menu>
								}
							</div>
						}
						@if (group.items.length == 0 && (group.map || groups.length === 1)) {
							<div class="geen-favorieten" [class.in-map]="group.map">
								<span>Geen favorieten</span>
							</div>
						}
					</div>
				}
			</div>
		}
	</div>
}

<ng-template #deleteMapDialog let-group>
	<app-confirm-dialog action="Verwijderen" caption="Map verwijderen">
		<span>
			Je staat op het punt om de map <b>{{ group.map!.naam }}</b> te verwijderen.
		</span>
		@if (group.items.length > 0) {
			<span>Deze map bevat favorieten die verloren zullen gaan als je de map verwijdert.</span>
		}
		<span>Weet je het zeker?</span>
	</app-confirm-dialog>
</ng-template>

<ng-template #deleteFavorietDialog let-favoriet>
	<app-confirm-dialog action="Verwijderen" caption="Favoriet verwijderen">
		Je staat op het punt om de favoriet <b>{{ favoriet.naam }}</b> te verwijderen. Weet je het zeker?
	</app-confirm-dialog>
</ng-template>
